import type { RestRecord } from '@libs/data-access/entities'
import type { Moment } from 'moment'

import { HALF_DAY } from '../RestFormSection/components/DayFields/DayFields'

export const getDefaultDateRange = ({
  defaultStart,
  defaultEnd
}: {
  defaultStart: Moment
  defaultEnd: Moment
  rest?: RestRecord
}) => {
  const endDate = defaultEnd
    .clone()
    .subtract(defaultEnd.hour() === 0 ? 1 : 0, 'days')

  return {
    start: {
      date: defaultStart.format('YYYY-MM-DD'),
      halfDay:
        defaultStart.hour() === 12 ? HALF_DAY.AFTERNOON : HALF_DAY.MORNING
    },
    end: {
      date: endDate.format('YYYY-MM-DD'),
      halfDay: defaultEnd.hour() === 12 ? HALF_DAY.MORNING : HALF_DAY.AFTERNOON
    }
  }
}
